import React, { useState } from 'react';
import { AlertCircle } from 'lucide-react';

const PasswordProtection = ({ onAuthenticate }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  
  const DEVELOPMENT_PASSWORD = 'demo123'; // Ändern Sie dies zu Ihrem gewünschten Passwort
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === DEVELOPMENT_PASSWORD) {
      localStorage.setItem('isAuthenticated', 'true');
      onAuthenticate(true);
      setError(false);
    } else {
      setError(true);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-600 to-indigo-900 p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Entwicklungsversion</h2>
          <p className="text-gray-600">Diese Seite befindet sich in der Entwicklung.</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                Passwort
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Entwicklungspasswort eingeben"
              />
            </div>

            {error && (
              <div className="flex items-center gap-2 text-red-600 text-sm">
                <AlertCircle className="w-4 h-4" />
                <span>Falsches Passwort</span>
              </div>
            )}

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg px-4 py-2 font-medium hover:from-blue-700 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Zugreifen
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PasswordProtection;